// extracted by mini-css-extract-plugin
export default {"hero":"hero_hero__IhAYi","hero_paragraph":"hero_hero_paragraph__rFH9G","arrow":"hero_arrow__BZ0nm"};